import type { Contest } from '~/domains/contest/domains/services/interfaces/contest.interface';

import { INITIAL_LOOKAHEAD, MAX_BATCH_SIZE } from '../constants/rail';

export type RailPage = { offset: number; requestedCount: number; contests: Contest[] };

export const getFullyVisibleCount = ({
  railWidth,
  slideWidth,
  gapWidth,
}: {
  railWidth: number;
  slideWidth: number;
  gapWidth: number;
}): number => Math.max(1, Math.floor((railWidth + gapWidth) / (slideWidth + gapWidth)));

export const getFirstBatchSize = (fullyVisibleCount: number, totalIds: number): number =>
  Math.min(fullyVisibleCount + INITIAL_LOOKAHEAD, totalIds, MAX_BATCH_SIZE);

export const getNextBatchOffset = (lastPage: RailPage, totalIds: number): number | undefined => {
  const nextOffset = lastPage.offset + lastPage.requestedCount;
  return nextOffset >= totalIds ? undefined : nextOffset;
};

export const orderByContestIds = (
  contestIds: readonly string[],
  rows: readonly Contest[]
): Contest[] => {
  const rowsById = new Map(rows.map((row) => [row.id, row]));
  return contestIds.flatMap((id) => {
    const row = rowsById.get(id);
    return row ? [row] : [];
  });
};
